export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-blind-02791b40dc26329c5a85151f809cefa2.svg";